module.exports = __webpack_public_path__ + "static/img/sun.1578211.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sun.png
// module id = U0tv
// module chunks = 1